export const CODE_SET_BOX = 'CODE_SET_BOX';



/** WEBPACK FOOTER **
 ** ./src/store/modules/code/types.js
 **/